// INACTIVITY-UI-GROUP-003 — presentation only. Marks every coverage_detail entry as the FIRST or a REPEAT
// reference to the same recorded break/downtime RECORD (by record_id, never by label/time) across a
// gap list, so the "Recorded Lunch … 54m" line is shown once and later rows say "Same Lunch".
export const annotateSharedCoverage = (gaps) => {
  const seen = new Set();
  return (gaps || []).map((g) => ({
    ...g,
    coverage_detail: (g.coverage_detail || []).map((c) => {
      const key = c.record_id || null;
      const repeat = !!key && seen.has(key);
      if (key) seen.add(key);
      return { ...c, _shared_repeat: repeat };
    }),
  }));
};
